/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste a list of numbers to build a histogram. The values are automatically grouped into bins and the chart shows how many fall into each range, revealing the shape of the distribution.`)
};

const es_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pega una lista de números para crear un histograma. Los valores se agrupan automáticamente en intervalos y el gráfico muestra cuántos caen en cada rango, revelando la forma de la distribución.`)
};

const de_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fügen Sie eine Liste von Zahlen ein, um ein Histogramm zu erstellen. Die Werte werden automatisch in Klassen gruppiert, und das Diagramm zeigt, wie viele in jeden Bereich fallen, wodurch die Form der Verteilung sichtbar wird.`)
};

const nl_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plak een lijst getallen om een histogram te bouwen. De waarden worden automatisch gegroepeerd in klassen en de grafiek toont hoeveel er in elk bereik vallen, wat de vorm van de verdeling onthult.`)
};

const fr_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Collez une liste de nombres pour créer un histogramme. Les valeurs sont automatiquement regroupées en classes et le graphique montre combien tombent dans chaque plage, révélant la forme de la distribution.`)
};

const it_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Incolla un elenco di numeri per costruire un istogramma. I valori vengono raggruppati automaticamente in classi e il grafico mostra quanti rientrano in ciascun intervallo, rivelando la forma della distribuzione.`)
};

const pt_br2_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma lista de números para criar um histograma. Os valores são agrupados automaticamente em faixas e o gráfico mostra quantos caem em cada intervalo, revelando o formato da distribuição.`)
};

const pt_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cole uma lista de números para construir um histograma. Os valores são agrupados automaticamente em classes e o gráfico mostra quantos caem em cada intervalo, revelando a forma da distribuição.`)
};

const ja_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数値のリストを貼り付けるとヒストグラムが作成されます。値は自動的にビンにグループ化され、グラフは各範囲に含まれる数を示し、分布の形を明らかにします。`)
};

const zh_hist_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`粘贴一组数字以构建直方图。数值会自动分组到区间中，图表显示每个区间内的数量，从而揭示分布的形态。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const hist_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.hist_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("hist_intro", locale)
	if (locale === "en") return en_hist_intro(inputs)
	if (locale === "es") return es_hist_intro(inputs)
	if (locale === "de") return de_hist_intro(inputs)
	if (locale === "nl") return nl_hist_intro(inputs)
	if (locale === "fr") return fr_hist_intro(inputs)
	if (locale === "it") return it_hist_intro(inputs)
	if (locale === "pt-BR") return pt_br2_hist_intro(inputs)
	if (locale === "pt") return pt_hist_intro(inputs)
	if (locale === "ja") return ja_hist_intro(inputs)
	return zh_hist_intro(inputs)
};